import React from "react";
import type { IconProps } from "./types";

const PencilIcon: React.FC<IconProps> = ({
  size = 18,
  color = "#D0D3DB",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.202.798a2.73 2.73 0 00-3.857 0L1.103 13.041A3.74 3.74 0 000 15.7v1.546A.753.753 0 00.753 18h1.545a3.737 3.737 0 002.661-1.102L17.202 4.654a2.73 2.73 0 000-3.856zM3.895 15.834c-.425.421-.998.659-1.597.66h-.792v-.792a2.243 2.243 0 01.661-1.597l9.291-9.291 1.732 1.731-9.295 9.289zM16.137 3.59l-1.886 1.887L12.52 3.75l1.887-1.888a1.223 1.223 0 011.727 1.732l.003-.004z"
      fill={color}
    />
  </svg>
);

export default PencilIcon;
